import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchConvenios } from "../redux/conveniosSlice";
import { Accordion, Alert, Placeholder, Button } from "react-bootstrap";
import { resolverUrlArchivo } from "../utils/resolverUrlArchivo";
import "../styles/DocumentosPage.css";
import { markdownLigeroAHtml } from "../utils/richText";
import useEnlaceExterno from "../utils/useEnlaceExterno";

const PublicConveniosPage = () => {
  const dispatch = useDispatch();
  const { convenios, loading, error } = useSelector((state) => state.convenios);
  const onClickEnlace = useEnlaceExterno();

  useEffect(() => {
    dispatch(fetchConvenios());
  }, [dispatch]);

  return (
    <div
      className="documentos-container"
      role="main"
      aria-label="Página de convenios para socios"
    >
      <div className="documentos-header" aria-label="Encabezado de convenios">
        <img
          src="https://api.sinterec.cl/public/images/SINTEREC_logo.jpg"
          alt="Logo SINTEREC"
          className="logo-sinterec"
          aria-hidden="true"
        />
        <h1 className="documentos-title" aria-level="1">
          Convenios para nuestros socios
        </h1>
      </div>

      {error && (
        <Alert variant="danger" dismissible role="alert" aria-live="assertive">
          <strong>Error:</strong> {error}
        </Alert>
      )}

      {loading ? (
        <Accordion
          className="documentos-accordion"
          aria-label="Cargando convenios..."
        >
          {[1, 2, 3].map((index) => (
            <Accordion.Item
              eventKey={index.toString()}
              key={index}
              className="documento-item"
              aria-hidden="true"
            >
              <Accordion.Header className="documento-header">
                <div className="d-flex justify-content-between align-items-center w-100">
                  <div className="d-flex align-items-center">
                    <i
                      className="bi bi-file-earmark-fill documento-icon me-3 text-primary"
                      aria-hidden="true"
                    ></i>
                    <span className="documento-title">
                      <Placeholder as="div" animation="glow">
                        <Placeholder xs={6} />
                      </Placeholder>
                    </span>
                  </div>
                  <div className="text-muted documento-date">
                    <Placeholder as="div" animation="glow">
                      <Placeholder xs={4} />
                    </Placeholder>
                  </div>
                </div>
              </Accordion.Header>
              <Accordion.Body className="documento-body">
                <Placeholder as="p" animation="glow">
                  <Placeholder xs={12} />
                  <Placeholder xs={8} />
                </Placeholder>
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      ) : (
        <>
          {convenios && convenios.length > 0 ? (
            <Accordion
              className="documentos-accordion"
              role="region"
              aria-label="Lista de convenios disponibles"
            >
              {convenios.map((convenio, index) => {
                const urlDocumento = resolverUrlArchivo(convenio.urlFinal);

                return (
                  <Accordion.Item
                    eventKey={index.toString()}
                    key={convenio.id}
                    className="documento-item"
                    aria-labelledby={`convenio-heading-${index}`}
                  >
                    <Accordion.Header
                      className="documento-header"
                      id={`convenio-heading-${index}`}
                    >
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <div className="d-flex align-items-center">
                          <i
                            className="bi bi-hand-thumbs-up-fill documento-icon me-3 text-primary"
                            aria-hidden="true"
                          ></i>
                          <span className="documento-title">
                            {convenio.titulo}
                          </span>
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body
                      className="documento-body"
                      id={`convenio-content-${index}`}
                      aria-labelledby={`convenio-heading-${index}`}
                    >
                      <div
                        aria-label={`Descripción del convenio: ${convenio.descripcion}`}
                        onClick={onClickEnlace}
                        style={{ whiteSpace: "pre-wrap" }}
                        dangerouslySetInnerHTML={{
                          __html: markdownLigeroAHtml(convenio.descripcion),
                        }}
                      />
                      {urlDocumento && (
                        <div className="d-flex gap-2 mt-2">
                          <Button
                            variant="outline-primary"
                            href={urlDocumento}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="documento-btn"
                            aria-label={`Ver documento del convenio ${convenio.titulo} (se abre en nueva ventana)`}
                          >
                            <i
                              className="bi bi-file-earmark-text me-1"
                              aria-hidden="true"
                            ></i>
                            Ver documento
                          </Button>
                        </div>
                      )}
                    </Accordion.Body>
                  </Accordion.Item>
                );
              })}
            </Accordion>
          ) : (
            <Alert
              variant="info"
              className="mt-4"
              role="status"
              aria-live="polite"
            >
              No hay convenios disponibles en este momento.
            </Alert>
          )}
        </>
      )}
    </div>
  );
};

export default PublicConveniosPage;
